module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.174c02fc.ttf";